export class BookingAdapter {
    constructor(booking) {
        this.booking = booking;
    }
    get startTime() {
        return this.booking.startDate.toISOString();
    }
    get numberOfParticipants() {
        return this.booking.numberOfParticipants;
    }
}
//# sourceMappingURL=booking.js.map